import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hero-banner" }
const _hoisted_2 = ["srcset"]
const _hoisted_3 = ["src"]

import { computed } from 'vue'
import { useTheme } from '@/composables/useTheme'


export default /*@__PURE__*/_defineComponent({
  __name: 'HeroBanner',
  setup(__props) {

const { getAssetPath } = useTheme()

const heroBanner = computed(() => getAssetPath('heroBanner') || '/img/images/banners/banner-lg.png')
const heroBannerMobile = computed(() => getAssetPath('heroBannerMobile') || '/img/images/banners/banner-sm.png')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("picture", null, [
      _createElementVNode("source", {
        media: "(min-width: 768px)",
        srcset: heroBanner.value
      }, null, 8, _hoisted_2),
      _createElementVNode("img", {
        src: heroBannerMobile.value,
        alt: "Lottery Balls"
      }, null, 8, _hoisted_3)
    ])
  ]))
}
}

})